import { connect, useSelector } from 'react-redux'
import { CountryCode } from '@carsys/enums/country-code'
import { IRootReducerState } from 'state/rootReducer'

import If from '@cbgms/base/utils/If'

/*
 * This component renders the passed children based on the shops
 * visitor country and the passed country prop.
 */

const checkCountry = (needle: CountryCode, haystack: CountryCode | CountryCode[]) =>
  needle && Array.isArray(haystack) ? haystack.includes(needle) : needle === haystack

export const useHasCountryFeature = (countries: CountryCode | CountryCode[]) => {
  const check = useHasCountryFeatureFunc()
  return check(countries)
}

export const useHasCountryFeatureFunc = () => {
  const visitorCountry = useSelector((state: IRootReducerState) => state.auth.shop.VisitorCountry)
  return (countries: CountryCode | CountryCode[]) => checkCountry(visitorCountry, countries)
}

interface OuterProps {
  /** The country or countries used to decide if the children should be rendered */
  countries?: CountryCode | CountryCode[]
  inverted?: boolean
}

export interface MapStateToProps {
  condition: boolean
}

const mapStateToProps = (state: IRootReducerState, props: OuterProps): MapStateToProps => {
  const shopVisitorCountry = state.auth.shop.VisitorCountry

  if (!props.countries) {
    return { condition: true }
  }

  let condition = checkCountry(shopVisitorCountry, props.countries)
  condition = props.inverted ? !condition : condition
  return { condition }
}

const CountryFeature = connect(mapStateToProps)(If)

if (!__PRODUCTION__) {
  CountryFeature.displayName = 'CountryFeature'
}

export default CountryFeature
